import { render } from "./project_metadata.vue?vue&type=template&id=38c62c8c"
import script from "./project_metadata.vue?vue&type=script&lang=js"
export * from "./project_metadata.vue?vue&type=script&lang=js"

import "./project_metadata.vue?vue&type=style&index=0&id=38c62c8c&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__